"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settings.systemCommunicationLabel': 'System Communication',
    'whatsapp.settings.systemCommunicationHint': 'When enabled, this bot will be used as the default system communication channel. Only one bot can hold this role at a time.',
    'whatsapp.settings.systemCommunicationGroupLabel': 'Group for bot to admin communications',
    'whatsapp.settings.systemCommunicationGroupHint': 'Select the group that the bot will use to send system messages to administrators. Used when system communication is enabled.',
    'whatsapp.settings.selectGroup': 'Select Group',
    'whatsapp.settings.title': 'WhatsApp Settings',
    'whatsapp.settings.description': 'Connect and manage your WhatsApp account via QR code login.',
    'whatsapp.settings.status': 'Connection Status',
    'whatsapp.settings.statusConnected': 'Connected',
    'whatsapp.settings.statusDisconnected': 'Disconnected',
    'whatsapp.settings.entityLabel': 'Entity ID',
    'whatsapp.settings.logout': 'Logout',
    'whatsapp.settings.entityIdLabel': 'Entity ID (phone number or identifier)',
    'whatsapp.settings.entityIdPlaceholder': 'Enter phone number or entity ID',
    'whatsapp.settings.startLogin': 'Start Login',
    'whatsapp.settings.qrTitle': 'QR Code',
    'whatsapp.settings.qrInstruction': 'Open WhatsApp on your phone > Settings > Linked Devices > Link a Device > Scan this QR code.',
    'whatsapp.settings.logsTitle': 'Connection Logs',
    'whatsapp.settings.clearLogs': 'Clear',
    'whatsapp.settings.noLogs': 'No logs yet. Start a login process to see connection logs.',
    'whatsapp.settings.noSettings': 'No phone number configuration available. Create one to get started.',
    'whatsapp.settings.creator': 'Created by',
    'whatsapp.settings.pinMessageLabel': 'Pinned message',
    'whatsapp.settings.pinMessagePlaceholder': 'Message content to pin in the conversation',
    'whatsapp.settings.pinMessageHint': 'If filled, this message will be pinned for this number.',
    'whatsapp.settings.pingerLabel': 'Pinger',
    'whatsapp.settings.pingerHint': 'When enabled, this bot periodically sends ping messages to keep the connection alive.',
    'whatsapp.settings.phoneTitle': 'Phone Number Settings',
    'whatsapp.settings.formTitle': 'WhatsApp Configuration',
    'whatsapp.settings.phoneLabel': 'Phone Number',
    'whatsapp.settings.titleLabel': 'Title',
    'whatsapp.settings.titlePlaceholder': 'e.g. Main account, Support line...',
    'whatsapp.settings.phonePlaceholder': 'Enter phone number (e.g. +1234567890)',
    'whatsapp.settings.phoneHint': 'Enter the phone number registered with WhatsApp, including country code.',
    'whatsapp.settings.reportEmailLabel': 'Report Emails',
    'whatsapp.settings.reportEmailPlaceholder': 'Add email addresses for summary reports',
    'whatsapp.settings.reportEmailHint': 'Group conversation summaries will be sent to these email addresses. Press Enter to add each email.',
    'whatsapp.settings.languageLabel': 'Bot Language',
    'whatsapp.settings.languageHint': 'Language used by the bot when responding to messages and generating summaries.',
    'whatsapp.settings.communicationTypeLabel': 'Communication Type',
    'whatsapp.settings.communicationTypeHint': 'Select the communication channel used by this bot.',
    'whatsapp.settings.communicationType.wa': 'WhatsApp',
    'whatsapp.settings.communicationType.tele': 'Telegram',
    'whatsapp.settings.apiIdLabel': 'Telegram API ID',
    'whatsapp.settings.apiIdPlaceholder': 'Enter Telegram API ID',
    'whatsapp.settings.apiIdHint': 'Numeric API ID obtained from my.telegram.org.',
    'whatsapp.settings.apiHashLabel': 'Telegram API Hash',
    'whatsapp.settings.apiHashPlaceholder': 'Enter Telegram API Hash',
    'whatsapp.settings.apiHashHint': 'API hash string obtained from my.telegram.org.',
    'whatsapp.settings.telegramApiLink': 'Get API ID and Hash for telegram account',
    'whatsapp.settings.botResponseConditionLabel': 'Bot Response Condition',
    'whatsapp.settings.botResponseConditionPlaceholder': 'Describe when the bot should respond, e.g. "Questions about opening hours, prices, or services"',
    'whatsapp.settings.botResponseConditionHint': 'The bot will respond to user messages that match this condition. Leave empty to disable automatic responses.',
    'whatsapp.settings.avatarLabel': 'Avatar',
    'whatsapp.settings.selectAvatar': '-- Select Avatar --',
    'whatsapp.settings.avatarHint': 'Select an avatar to use for AI-powered responses on this WhatsApp number.',
    'whatsapp.settings.save': 'Save Settings',
    'whatsapp.settings.startAgent': 'Start Agent',
    'whatsapp.settings.stopAgent': 'Stop Agent',
    'whatsapp.settings.agentRunning': 'Agent Running',
    'whatsapp.settings.agentInitializing': 'Initializing...',
    'whatsapp.settings.agent_status_active': 'Active',
    'whatsapp.settings.agent_status_initializing': 'Initializing',
    'whatsapp.settings.agent_status_inactive': 'Inactive',
    'whatsapp.settings.telegramAuthTitle': 'Telegram Authentication',
    'whatsapp.settings.telegramCodeInstruction': 'Enter the verification code sent to your Telegram account.',
    'whatsapp.settings.telegramCodePlaceholder': 'Code',
    'whatsapp.settings.telegramCodeSubmit': 'Submit Code',
    'whatsapp.settings.telegramPasswordInstruction': 'Enter your Telegram two-factor authentication password.',
    'whatsapp.settings.telegramPasswordPlaceholder': 'Password',
    'whatsapp.settings.telegramPasswordSubmit': 'Submit Password',
    'whatsapp.settings.pop3.title': 'Email Reporting',
    'whatsapp.settings.pop3.description': 'Configure email servers for email fetching and monitoring.',
    'whatsapp.settings.pop3.add': 'Add Server',
    'whatsapp.settings.pop3.empty': 'No email servers configured. Click "Add Server" to create one.',
    'whatsapp.settings.pop3.untitled': 'Untitled Server',
    'whatsapp.settings.pop3.host.label': 'Server Host',
    'whatsapp.settings.pop3.host.placeholder': 'pop.example.com',
    'whatsapp.settings.pop3.port.label': 'Port',
    'whatsapp.settings.pop3.port.placeholder': '995',
    'whatsapp.settings.pop3.username.label': 'Username',
    'whatsapp.settings.pop3.username.placeholder': 'Enter email or username',
    'whatsapp.settings.pop3.password.label': 'Password',
    'whatsapp.settings.pop3.password.placeholder': 'Enter password',
    'whatsapp.settings.pop3.useTls.label': 'Use TLS/SSL',
    'whatsapp.settings.pop3.enabled.label': 'Enabled',
    'whatsapp.settings.pop3.save': 'Save Email Settings',
    'whatsapp.settings.pop3.isGmail.label': 'Gmail',
    'whatsapp.settings.pop3.isGmail.hint': 'Enable to connect via Google OAuth instead of IMAP credentials.',
    'whatsapp.settings.pop3.gmail.info': 'Click "Connect Gmail" to authorize access to your Gmail inbox via Google OAuth.',
    'whatsapp.settings.pop3.configure': 'Configure Email',
    'whatsapp.settings.pop3.enabled.yes': 'Enabled',
    'whatsapp.settings.pop3.enabled.no': 'Disabled',
    'whatsapp.settings.pop3.actions': 'Actions',
    'whatsapp.settings.pop3.remove': 'Remove',
    'whatsapp.settings.pop3.remove.failed': 'Failed to remove email account.',
    'whatsapp.settings.pop3.remove.confirm': 'Are you sure you want to remove this email account?',
    'whatsapp.settings.pop3.removed': 'Email account removed successfully.',
    'whatsapp.settings.pop3.saved': 'Email settings saved successfully.',
    'whatsapp.settings.pop3.host.required': 'Server host is required.',
    'whatsapp.settings.pop3.gmail.label': 'Gmail',
    'whatsapp.settings.pop3.gmail.connect': 'Connect with Gmail',
    'whatsapp.settings.pop3.gmail.disconnect': 'Disconnect Gmail',
    'whatsapp.settings.pop3.gmail.connected': 'Gmail connected',
    'whatsapp.settings.pop3.gmail.notConnected': 'Gmail not connected',
    'whatsapp.settings.pop3.gmail.authFailed': 'Gmail authentication failed.',
    'whatsapp.settings.pop3.gmail.disconnected': 'Gmail disconnected successfully.',
    'whatsapp.settings.pop3.gmail.disconnectFailed': 'Failed to disconnect Gmail.',
    'whatsapp.settings.pop3.gmail.authWindowOpened': 'Gmail authentication window opened.',
};
